module.exports = __webpack_public_path__ + "img/bg.55c2c8a5.png";